import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  getHotelBookingDetailById,
  getHotelBookingPdf,
} from "../services/auth/authServices";
import { Button, Col, Row } from "antd";
import DOMPurify from "dompurify";
import { locationImg } from "../utils/ImagePath";

const BookingHotelDetail = ({ booking_id }) => {
  const [bookingData, setBookingData] = useState(null);
  const [loader, setLoading] = useState(null);

  const fetchBookingData = async () => {
    try {
      setLoading();
      const response = await getHotelBookingDetailById(booking_id);
      if (response?.bookingData) {
        setBookingData(response.bookingData);
      }
    } catch (error) {
      console.error("Error fetching booking data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (booking_id) {
      fetchBookingData();
    }
  }, [booking_id]);

  //console.log("bookingData", bookingData);

  const generatePdf = async () => {
    setLoading(true);
    try {
      const response = await getHotelBookingPdf(booking_id);
      setLoading(false);
      const file = new Blob([response], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(file);
      link.download = "ticket.pdf";
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (error) {
      setLoading(false);
      console.error("Error downloading the PDF:", error);
    }
  };

  const listStyle = {
    listStyle: "disc",
    borderBottom: "1px solid #ddd",
    marginBottom: "5px",
  };

  const sanitizedhotelPolicy = DOMPurify.sanitize(
    bookingData?.[0]?.hotel_policy || ""
  );

  return (
    <div className="content-wrapper">
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1>Booking Detail</h1>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="invoice p-3 mb-3">
                {/* title row */}
                <Row gutter={20} className="mb-4">
                  <Col md={12} className="border-end">
                    <div className="smt_invoice_left">
                      <address>
                        <strong>SUPERB WORLD TRIP</strong>
                        <br />
                        SECOND FLOOR NEHRU HOUSE
                        <br />
                        4 BAHADUR SHAH ZAFAR MARG ITO
                        <br />
                        NEW DELHI, INDIA
                        <br />
                        Phone: (+91) 9312241999
                        <br />
                        Email: booking@superbworldtrip.com
                      </address>
                    </div>
                  </Col>
                  <Col md={12}>
                    <div className="smt_invoice_left">
                      <h4>
                        <i className="fas fa-globe" />
                        <small className="float-right">
                          <b>Date:</b>{" "}
                          {moment(bookingData?.booking_date).format("LLLL")}
                        </small>
                      </h4>
                      <h4>
                        Booking ID: <b>{bookingData?.[0]?.swt_booking_id}</b>
                      </h4>
                      <p className="mb-0">
                        Hotel Name: {bookingData?.[0]?.hotel_name}
                      </p>
                      <p className="mb-0">
                        Address: {bookingData?.[0]?.hotel_address}{" "}
                      </p>
                      <p className="mb-0">
                        Contact Email: {bookingData?.[0]?.billing_email}
                      </p>
                      <p className="mb-0 mt-2">
                        <a
                          href={bookingData?.[0]?.maplinks || "#"}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {bookingData?.[0]?.maplinks ? <img src={locationImg} alt='location-img' width={'30px'} /> : "No Link Available"}
                        </a>
                      </p>

                      {console.log("bookingData?.maplinks", bookingData?.[0]?.maplinks)}
                    </div>
                  </Col>
                </Row>

                <div className="row">
                  <div className="col-12 mb-3">
                    <table className="table table-striped border-bottom mb-4">
                      <thead>
                        <tr>
                          <th
                            className="smt_width_6 smt_semi_bold smt_primary_color smt_gray_bg"
                            colspan="5"
                          >
                            Passenger Information
                          </th>
                        </tr>
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Contact No.</th>
                          <th>Email.</th>
                        </tr>
                      </thead>
                      <tbody>
                        {bookingData?.[0]?.rooms?.[0]?.passengers?.map(
                          (passenger, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td className="text-capitalize">
                                {passenger?.first_name} {passenger?.last_name}
                              </td>
                              <td>
                                {bookingData?.[0]?.billing_phone_no ?? "---"}
                              </td>
                              <td>
                                {bookingData?.[0]?.billing_email ?? "---"}
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="col-12">
                    <table className="table table-striped border-bottom mb-4">
                      <thead>
                        <tr>
                          <th>Check-in/Check-out </th>
                          <th>Room Type/ Plan Details</th>
                          <th>Amount Including All Taxes</th>
                        </tr>
                      </thead>
                      <tbody>
                        {bookingData?.[0]?.rooms?.map((room, index) => (
                          <tr key={index}>
                            {/* <td>{index + 1}</td> */}
                            <td className="text-capitalize">
                              {moment(bookingData?.[0]?.from_date).format(
                                "DD MMM YYYY"
                              )}{" "}
                              -{" "}
                              {moment(bookingData?.[0]?.to_date).format(
                                "DD MMM YYYY"
                              )}
                            </td>
                            <td>{room?.room_type_name ?? "---"}</td>
                            <td>
                              {Math.round(bookingData?.[0]?.total_amount)}
                            </td>
                            {/* <td>{passenger?.passport_number ?? "---"}</td> */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                {/* <Row className="row">
                    <Col md={12}></Col>
                  <Col md={12} className="">
                    <p className="smt_mb2">
                      <b className="smt_primary_color">Room Information:</b>
                    </p>
                    <table>
                      <tbody>
                       
                        <tr className="smt_border_top">
                          <td className="smt_width_3 smt_border_top_0 smt_bold smt_f16 smt_primary_color">
                            Total Amount:{" "}
                          </td>
                          <td className="smt_width_3 smt_border_top_0 smt_bold smt_f16 smt_primary_color smt_text_right">
                            <b>{bookingData?.[0]?.total_amount}</b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Col>
                </Row> */}

                <Row gutter={20} className="mt-3">
                  <Col md={24}>
                    <h3 className="mb-2">Booking Terms & Conditions</h3>
                    <ul className="ps-3">
                      <li style={listStyle}>
                        You must present a photo ID at the time of check in.
                        Hotel may ask for credit card or cash deposit for the
                        extra services at the time of check in.
                      </li>
                      <li style={listStyle}>
                        All extra charges should be collected directly from
                        clients prior to departure such as parking, phone calls,
                        room service, city tax, etc.
                      </li>
                      <li style={listStyle}>
                        We don't accept any responsibility for additional
                        expenses due to the changes or delays in air, road,
                        rail, sea or indeed of any other causes, all such
                        expenses will have to be borne by passengers.
                      </li>
                      <li style={listStyle}>
                        In case of wrong residency & nationality selected by
                        user at the time of booking; the supplement charges may
                        be applicable and need to be paid to the hotel by guest
                        on check in/ check out.
                      </li>
                      <li style={listStyle}>
                        Any special request for bed type, early check in, late
                        check out, smoking rooms, etc are not guaranteed as
                        subject to availability at the time of check in.
                      </li>
                      <li style={listStyle}>
                        Early check out will attract full cancellation charges
                        unless otherwise specified.
                      </li>
                    </ul>
                  </Col>
                  <hr />
                  <Col md={24} className="mt-3">
                    {sanitizedhotelPolicy && (
                      <>
                        <h3 className="mb-2">Hotel Policies</h3>
                        <div
                          style={listStyle}
                          dangerouslySetInnerHTML={{
                            __html: sanitizedhotelPolicy,
                          }}
                        />
                      </>
                    )}
                  </Col>
                </Row>

                <Button
                  type="button"
                  className="btn btn-primary mt-4"
                  onClick={generatePdf}
                  disabled={loader}
                   aria-label="generate pdf"
                >
                  Generate PDF
                </Button>

                {/* {loader && <span>Please wait ...</span>} */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BookingHotelDetail;
